import { Platform } from "react-native";
import * as Haptic from "expo-haptics";

export function onPressInHaptic() {
  if (Platform.OS === "ios") {
    Haptic.impactAsync(Haptic.ImpactFeedbackStyle.Medium);
  }
}
